import type { ParsedQuery } from 'query-string';
import type { V3To } from '../router/v3Bridge';

const AI_PREFIX = [
  'when',
  'what',
  'where',
  'who',
  'whom',
  'whose',
  'why',
  'which',
  'how',
];

// this logic is duplicated in the backend in lib/slab/ai/ask.ex,
// so any changes made here should also be made there.
export const isAiQuestion = (query: string) => {
  const lowercaseWords = query
    .toLowerCase()
    .trim()
    .split(/['`\s]+/);
  const restWords = lowercaseWords.slice(2);
  return (
    lowercaseWords.length >= 3 &&
    (AI_PREFIX.includes(lowercaseWords[0] ?? '') ||
      restWords.some((word) => word.endsWith('?')))
  );
};

export const getAiAskLocation = (location?: {
  pathname: string;
  query: ParsedQuery<string | undefined>;
}): V3To | undefined => {
  return location
    ? { ...location, query: { ...location.query, mode: 'ask' } }
    : location;
};
